// extracted by mini-css-extract-plugin
export default {"bannerImageToggle":"_44sLq___BrandedAssets-module__bannerImageToggle"};